import React from 'react'
import Event from '../../Event'

function MyActivity() {
    return <Event />
}

export default MyActivity
